import { render, staticRenderFns } from "./LotUpModal.vue?vue&type=template&id=c7987b20&scoped=true"
import script from "./LotUpModal.vue?vue&type=script&lang=js"
export * from "./LotUpModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7987b20",
  null
  
)

export default component.exports